export default function initAccordion(elem) {
  if (!document.querySelector(elem)) {
    return;
  }

  document.querySelector(elem).addEventListener('click', function (event) {
    if (!event.target.matches(`${elem} .accordion-trigger`)) return;
    else {
      if (!event.target.parentElement.classList.contains('active')) {
        // remove active class from all other accordions
        var elementList = document.querySelectorAll(`${elem} .accordion-section`);
        Array.prototype.forEach.call(elementList, function (e) {
          e.classList.remove('active');
        });
        //add active class on cliked accordion
        event.target.parentElement.classList.add('active');
        window.scrollTo({
          top: event.target.offsetTop - 120,
          behavior: 'smooth',
        });
      } else {
        //remove active class on cliked accordion
        event.target.parentElement.classList.remove('active');
      }
    }
  });
}
